<template>
  <div class="contact animatedBox">
    <div class="container fluid">
      <div class="card p-1">
        <fd-table
          :componentTitle="'People Contacted Us'"
          :tableButton="actionButton"
          :indexed="true"
          :plugin="{
            search: [1, 2],
          }"
          :searchBarTitle="'Search from First Name...'"
          :getFunction="getAllContacts"
        ></fd-table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "contact",
  data() {
    return {
      actionButton: [
        {
          title: "View",
          class: "update",
          routerLink: "/contact/detail",
        },
      ],
    };
  },
  methods: {
    async getAllContacts(keyword, currentPage, perPage, isLoading) {
      const request = await this.$store.dispatch("contact/getAllContact", {
        keyword: keyword,
        currentPage: currentPage,
        perPage: perPage,
        isLoading: isLoading,
      });

      return request;
    },
  },
};
</script>

<style>
.contact {
}
</style>